import { StyledEngineProvider } from '@mui/material';
import React, { ReactNode } from 'react';
import { setupCameraControls } from '../CameraControls/CameraControls';
import { Themed } from '../Themed/Themed';

setupCameraControls();

export const AppProvider = ({ children }: { children: ReactNode }) => (
  <StyledEngineProvider injectFirst>
    <Themed mode="underground">{children}</Themed>
  </StyledEngineProvider>
);
